import {
  Component,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import { IndustryService } from '../../../core/data/industry.service';
import { SnackbarQueueService } from '../../../core/utils/snackbar-queue/snackbar-queue.service';

import { Industry } from '../../../core/models/industry.model';

@Component({
  selector: 'idl-industry-edit',
  templateUrl: './industry-edit.component.html',
  styleUrls: ['./industry-edit.component.scss']
})
export class IndustryEditComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  @Input() addIndustry: boolean;
  @Input() industry: Industry;

  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Input() saveEvent: Observable<void>;

  submitted = false;

  industryForm = this._fb.group({
    name: ['', Validators.required],
    comments: ['']
  });

  constructor(
    private _industryService: IndustryService,
    private _fb: UntypedFormBuilder,
    private _snackBar: SnackbarQueueService
  ) {}

  ngOnInit() {
    this.saveEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => this.saveIndustry());

    this.industryForm.patchValue({
      name: this.industry.name,
      comments: this.industry.comments
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  saveIndustry() {
    this.submitted = true;

    this.industry.name = this.industryForm.value.name;
    this.industry.comments = this.industryForm.value.comments;

    this._industryService
      .edit(this.industry)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        industry => {
          this.submitted = false;

          if (this.addIndustry) {
            this._snackBar.show(
              'New industry successfully created.',
              'New Industry',
              {
                duration: 2000,
                verticalPosition: 'top'
              }
            );
          } else {
            this._snackBar.show('Industry successfully saved.', 'Saved', {
              duration: 2000,
              verticalPosition: 'top'
            });
          }

          this.saved.emit(industry);
        },
        err => {
          this._snackBar.show('Error saving industry.', 'Error', {
            duration: 5000,
            verticalPosition: 'top'
          });
        }
      );
  }
}
